
<div class="alertContainer" fxLayout="column">
  <h4 mat-dialog-title>{{titleContent}}</h4>
  <span class="msgContainer" >{{messageContent}}</span>
  <button mat-raised-button (click)="dialogRef.close()">Close</button>
</div>



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/alertComponent/alert.template.html